import React from 'react';
import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent } from '@ts/ui-models';
import { CLocation } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...ItemsConfig,
    componentId: 'locations',
    entity: 'location',
    filtersFetchData: { location: { isAlive: true } },
    mainClass: CLocation,
  };
};
const Locations = props => {
  const defaultProps = {
    flavorId: 'location',
    title: 'Locations',
    nameColumns: ['itemsInside'],
  };

  return <Items configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default Locations;
